import { useEffect, useState } from "react";
import { Link, NavLink, Navigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MasterGate } from "@/components/admin/master/MasterAuth";
import { AdminIntegracao, AdminCertificados } from "@/fiscal";
import { adminApi } from "@/lib/api";
import { FiscalDocumentosAdmin } from "@/components/admin/master/FiscalDocumentosAdmin";

const PAGES = { integracao: ["Integração", AdminIntegracao], certificados: ["Certificados", AdminCertificados], documentos: ["Documentos", FiscalDocumentosAdmin] };
const tabCls = ({ isActive }) => `rounded-md px-3 py-1.5 text-sm ${isActive ? "bg-blue-50 font-medium text-blue-700" : "text-gray-600 hover:bg-gray-50"}`;

export default function FiscalAdmin() {
  const { pagina } = useParams();
  const [logged, setLogged] = useState(null);
  useEffect(() => {
    adminApi.get("/me").then(() => setLogged(true)).catch(() => setLogged(false));
  }, []);
  if (!PAGES[pagina]) return <Navigate to="/fiscal/admin/integracao" replace />;
  if (logged === null) return null;
  if (!logged) return <MasterGate onLogged={() => setLogged(true)} />;
  const Page = PAGES[pagina][1];
  return (
    <div className="mx-auto max-w-7xl space-y-6 p-4 sm:p-8" data-testid="fiscal-admin-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><p className="eyebrow">Admin Master</p><h1 className="text-3xl font-bold">Fiscal</h1></div>
        <Link to="/admin" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="fiscal-admin-back-link">
          <ArrowLeft className="h-4 w-4" />Voltar ao Admin Master
        </Link>
      </div>
      <div className="space-y-4 rounded-xl border bg-white p-4 text-gray-900">
        <nav className="flex gap-1 border-b border-gray-200 pb-2">
          {Object.entries(PAGES).map(([k, [label]]) => (
            <NavLink key={k} to={`/fiscal/admin/${k}`} className={tabCls} data-testid={`fiscal-admin-nav-${k}`}>{label}</NavLink>
          ))}
        </nav>
        <Page />
      </div>
    </div>
  );
}
